import { AutogenLayoutOfficeTimecardHistoryReport } from "./autogen/AutogenLayoutOfficeTimecardHistoryReport";

export class OfficeTimecardHistoryReport extends AutogenLayoutOfficeTimecardHistoryReport {
    
    override onLoad(): void {
        this.textboxSort.selectedItem = this.textboxSort.items[0];
    }

    checkboxIncludeSettlementHistoryOnChange() {
        this.excludabletextboxPayees.textbox.clear();
        if(this.checkboxIncludeSettlementHistory.checked) {
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}
